import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.576 25" {...props}>
    <path d="M0 25v-2.082h1.041v-4.165H0v-2.082h1.041v-3.123H0V9.383h14.576v4.165h-1.041v3.123h1.041v2.082h-1.041v4.165h1.041V25zm12.493-13.534a1.038 1.038 0 0 0-1.041-1.042H9.37a1.04 1.04 0 1 0 0 2.083h2.082a1.04 1.04 0 0 0 1.041-1.041zM12.09 3.193v1.795a.368.368 0 0 1-.369.369H5.498c-1.047 0-1.294.907-1.35 1.412a.367.367 0 0 1-.365.324h-1.85a.366.366 0 0 1-.37-.36c-.003-1.033.303-3.909 3.92-3.909h1.906v-1.64H5.638V0h4.885v1.183H8.772v1.641h2.949a.37.37 0 0 1 .369.369z" />
  </svg>
);
export default SvgComponent;
